/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  InclinometryBody,
  InclinometryBodyXYZOnly,
  InclinometryCreateParameters,
  InclinometryCreationResult,
  InclinometryHeader,
} from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class InclinometryClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags Inclinometry
   * @summary Получение идентификаторов инклинометрий для скважины
   * @request GET:/geology/Inclinometry/for_well/{wellId}
   * @secure
   */
  inclinometryGetInclinometryIdsForWell = (wellId: string, params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/geology/Inclinometry/for_well/${wellId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Inclinometry
   * @summary Получение заголовка активной инклинометрии для скважины
   * @request GET:/geology/Inclinometry/for_well/{wellId}/active-header
   * @secure
   */
  inclinometryGetInclinometryHeaderForWell = (wellId: string, params: RequestParams = {}) =>
    this.http.request<InclinometryHeader, any>({
      path: `/geology/Inclinometry/for_well/${wellId}/active-header`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Inclinometry
   * @summary Получение заголовка инклинометрии по идентификатору
   * @request GET:/geology/Inclinometry/{inclinometryId}
   * @secure
   */
  inclinometryGetInclinometryHeader = (inclinometryId: string, params: RequestParams = {}) =>
    this.http.request<InclinometryHeader, any>({
      path: `/geology/Inclinometry/${inclinometryId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Inclinometry
   * @summary Получение тела инклинометрии (точки и углы) по идентификатору
   * @request GET:/geology/Inclinometry/{inclinometryId}/data
   * @secure
   */
  inclinometryGetInclinometryBody = (inclinometryId: string, params: RequestParams = {}) =>
    this.http.request<InclinometryBody, any>({
      path: `/geology/Inclinometry/${inclinometryId}/data`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Inclinometry
   * @summary Получение среза тела инклинометрии (только координаты - атрибуты x, y, zabs) по идентификатору
   * @request GET:/geology/Inclinometry/{inclinometryId}/data/xyz-only
   * @secure
   */
  inclinometryGetInclinometryBodyXyzOnly = (inclinometryId: string, params: RequestParams = {}) =>
    this.http.request<InclinometryBodyXYZOnly, any>({
      path: `/geology/Inclinometry/${inclinometryId}/data/xyz-only`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Inclinometry
   * @summary Получение упрощенного среза тела инклинометрии (только координаты - атрибуты x, y, zabs) по идентификатору
   * @request GET:/geology/Inclinometry/{inclinometryId}/data/xyz-only/simplified
   * @secure
   */
  inclinometryGetInclinometryBodyXyzOnlySimplified = (
    inclinometryId: string,
    query?: {
      /**
       * Допустимая погрешность,
       * @format double
       * @default 0.5
       */
      tolerance?: number
      /**
       * Округлять качественнее, но медленнее
       * @default true
       */
      highQualityEnabled?: boolean
    },
    params: RequestParams = {},
  ) =>
    this.http.request<InclinometryBodyXYZOnly, any>({
      path: `/geology/Inclinometry/${inclinometryId}/data/xyz-only/simplified`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Inclinometry
   * @summary Создание инклинометрии (из ГеоБД)
   * @request POST:/geology/Inclinometry
   * @secure
   */
  inclinometryCreate = (data: InclinometryCreateParameters, params: RequestParams = {}) =>
    this.http.request<InclinometryCreationResult[], any>({
      path: `/geology/Inclinometry`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
}
